import { Icon, Popover as initialPopover } from "@plum-xoxo/admin-dsm";
import React, { useState } from "react";
import ApplyFilterModal from "./ApplyFilterModal";
import StyledChip from "../../../../../components/styled/Chip";
import styled from "styled-components";
import moment from "moment";

const Popover = styled(initialPopover).attrs()`
  overflow: visible;
  .eui-option-inner:hover {
    background-color: ${(props) => props.theme.palette.light.c100};
  }
  .eui-option-child {
    font-weight: 400 !important;
    display: flex !important;
    .trigger {
      width: 100%;
    }
  }
`;
const DateFilter = ({
  initialColumns,
  applyFilter,
  currencyCode = "INR",
  chipProps = {},
  isFilterDisabled: initialFilterDisabled = false,
  selectedFilterIndex,
  title,
  type,
  hideReportOptions,
}) => {
  const [selected, setSelected] = useState(false);
  const columns = initialColumns;
  let dateColumnIndex = initialColumns.findIndex((col) => col.name === "date");
  let dateFilter = {};
  if (dateColumnIndex !== -1) {
    dateFilter = columns[dateColumnIndex].filter.filters;
  }
  return (
    <div>
      <Popover
        onVisibilityChange={(data) => {
          setSelected(data);
        }}
        content={
          <>
            <ApplyFilterModal
              columns={columns}
              applyFilter={applyFilter}
              showClear={false}
              title={title}
              type={type}
              index={dateColumnIndex}
            />
          </>
        }
        offset={[0, 16]}
        placement="bottom-end"
        width={360}
      >
        <StyledChip
          {...chipProps[selected ? "active" : "unactive"]}
          label={
            dateFilter.startDate && dateFilter.endDate
              ? `${moment(dateFilter.startDate).format(
                  "MMM DD, YYYY"
                )} to ${moment(dateFilter.endDate).format("MMM DD, YYYY")}`
              : "All Time"
          }
          textColor={"dark"}
          textShade={"c300"}
          size="medium"
          disabled={hideReportOptions}
          className={`ml-24 px-12`}
          id="reports-filter-btn"
          //   isFilterSelected={isFilterSelected}
          customTag={
            <div className="pl-4">
              <Icon
                iconName="DownArrow"
                className="mt-6"
                color={"dark"}
                shade={"c300"}
                size={16}
              />
            </div>
          }
        />
      </Popover>
    </div>
  );
};

export default DateFilter;
